<template lang="pug">
.dwelling-form
  Card.selections-card
    template(#header)
      .title {{ $t('selections.dwellingUpload.title') }}
    template(#content)
      .dwelling-message
        span {{ $t('selections.dwellingUpload.uploadMsg') }}
      .dwelling-upload-wrapper
        FileUpload.dwelling-upload(
          name="mprn"
          :auto="true"
          accept=".xml, .json"
          :multiple="false"
          :fileLimit="1"
          @upload="uploaded($event)"
          @error="uploaded($event)"
          url=""
        )
          template(#header="{ chooseCallback }")
            .files-button
              Button.mprn-button(@click="chooseCallback()" icon="pi pi-plus" :label="$t('selections.dwellingUpload.button')")
          template(#empty)
            .files-placeholder {{ $t('selections.dwellingUpload.placeholder') }}
</template>
<script lang="ts">
import { defineComponent } from "vue";
import Card from "primevue/card";
import FileUpload, { FileUploadUploadEvent } from "primevue/fileupload";
import Button from "primevue/button";
import { useRecommendations, useSelections } from "@/store";
import { GammaAPIService } from "@/service";
import { RequestRecommendationsResponse, ResponseError } from "@/types";
import { t } from "@/helpers/locale";
import { storeToRefs } from "pinia";
import { BerwowEvent, emit } from "@/helpers";

export default defineComponent({
  name: "DwellingForm",
  components: {
    Card,
    FileUpload,
    Button,
  },
  setup() {
    const selections = useSelections();
    const { setRecommendationsInfo } = useRecommendations();
    const { submitForm } = selections;
    const { submitLoading } = storeToRefs(selections);
    async function uploaded(e: FileUploadUploadEvent) {
      const file = (e.files as File[])[0];
      if (!file)
        return emit(BerwowEvent.RecommendationsError, {
          message: t("selections.dwellingUpload.unknownError"),
        });

      submitLoading.value = true;
      const response: RequestRecommendationsResponse | ResponseError =
        await GammaAPIService.getRecommendationsForFile(file);

      if ((response as RequestRecommendationsResponse)?.recommendationGroups) {
        setRecommendationsInfo(
          response as RequestRecommendationsResponse,
          true
        );
        await submitForm(false);
      } else {
        emit(
          BerwowEvent.RecommendationsError,
          (response as ResponseError)?.exceptionType
            ? response
            : { message: t("selections.dwellingUpload.unknownError") }
        );
      }

      submitLoading.value = false;
    }

    return {
      uploaded,
    };
  },
});
</script>
<style class="scss" scoped>
.dwelling-message {
  font-size: 1.1rem;
  padding: 0.3rem;
  margin-bottom: 1rem;
}

.files-placeholder {
  font-size: 2rem;
  text-align: center;
  opacity: 0.5;
  cursor: default;
  position: relative;
  bottom: 2rem;
}
</style>
